import { useDroppable } from '@dnd-kit/core';
import './TopLevelDropGap.scss';

interface TopLevelDropGapProps {
  insertIndex: number;
}

function TopLevelDropGap({ insertIndex }: TopLevelDropGapProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: `gap-${insertIndex}`,
    data: { type: 'gap', insertIndex },
  });

  return (
    <div
      ref={setNodeRef}
      className={`top-level-drop-gap${isOver ? ' active' : ''}`}
    />
  );
}

TopLevelDropGap.displayName = 'TopLevelDropGap';
export default TopLevelDropGap;
